import { Button, ButtonRow, Heading, TextArea } from '@ksyos/design-system';
import type { IStepProps } from '../OsasPatientQuestionnaire';
import { translateKey } from '../../../../../translate';
import { CustomContainer } from '../../../../elements/molecules/customContainer/CustomContainer';
import { Stack } from '../../../../elements/molecules/stack/Stack';
import { StyledFormGroup } from '../../../../elements/organisms/StyledFormGroup/StyledFormGroup';

export function Step4(props: IStepProps) {
    return (
        <>
            <CustomContainer>
                <Stack>
                    <Heading size="large">Suggesties en/of complimenten</Heading>
                </Stack>

                <Stack>
                    <StyledFormGroup
                        hasErrors={props.errors.has('satisfiedWith')}
                        label="Waar ben je tevreden over? (optioneel)"
                        layout="vertical"
                    >
                        <TextArea
                            autoResize
                            error={
                                props.errors.get('satisfiedWith')
                                    ? translateKey('validation.' + props.errors.get('satisfiedWith'))
                                    : undefined
                            }
                            onChange={(e) => {
                                const satisfiedWith = e.target.value !== '' ? e.target.value : null;
                                props.handleChange({ satisfiedWith });
                            }}
                            value={props.customControlData.satisfiedWith || ''}
                            variant="outline"
                        />
                    </StyledFormGroup>
                </Stack>

                <Stack>
                    <StyledFormGroup
                        hasErrors={props.errors.has('doneBetter')}
                        label="Wat kan anders en/of beter? (optioneel)"
                        layout="vertical"
                    >
                        <TextArea
                            autoResize
                            error={
                                props.errors.get('doneBetter')
                                    ? translateKey('validation.' + props.errors.get('doneBetter'))
                                    : undefined
                            }
                            onChange={(e) => {
                                const doneBetter = e.target.value !== '' ? e.target.value : null;
                                props.handleChange({ doneBetter });
                            }}
                            value={props.customControlData.doneBetter || ''}
                            variant="outline"
                        />
                    </StyledFormGroup>
                </Stack>

                <ButtonRow justify="right">
                    <Button
                        color="secondary"
                        onClick={props.goToPreviousStep}
                        variant="outline"
                    >
                        Terug
                    </Button>
                    {props.submit && (
                        <Button
                            color="secondary"
                            isDisabled={props.isSubmitting}
                            onClick={props.submit}
                            variant="solid"
                        >
                            {!props.isSubmitting ? 'Verzenden' : 'Bezig met verwerken...'}
                        </Button>
                    )}
                </ButtonRow>
            </CustomContainer>
        </>
    );
}
